/**
 * Утилитка для получения урла – в зависимости от наличия teamId и subject в урле выбирается один из трех путей
 * (чтобы не писать каждый раз тернарники)
 */
export const getGetPattern =
    (providedParams: { teamId?: string | number | undefined; subject?: string | undefined }) =>
    (pathVariants: { noParams: string; withTeamId?: string; withTeamIdAndSubject?: string }): string => {
        const { teamId, subject } = providedParams;
        const { noParams, withTeamId, withTeamIdAndSubject } = pathVariants;
        if (withTeamIdAndSubject && teamId && subject) {
            return withTeamIdAndSubject;
        } else if (withTeamId && teamId) {
            return withTeamId;
        }
        return noParams;
    };
